module.exports = __webpack_public_path__ + "img/maersk.377bf7b0.jpeg";